const regx = {
  // 手机号
  mobile: /^1[1-9]\d{9}$/, // eslint-disable-line
  // 座机号
  tel: /^(?:(?:0\d{2,3}[\-]{1}[1-9]\d{6,7}([\-]\d{3,6})?)|(?:[48]00[\-]?[1-9]\d{6}))$/, // eslint-disable-line
  // 社会信用代码
  socialCreditCode: /^([0-9A-HJ-NPQRTUWXY]{2}\d{6}[0-9A-HJ-NPQRTUWXY]{10}|[1-9]\d{14})$/, // eslint-disable-line
  // 邮政编码
  zipCode: /^[0-9]{6}$/, // eslint-disable-line
  //数字，可以有2位小数
  decimal: /^(\-)?\d+(\.?\d{1,2})?$/, // eslint-disable-line
  //正整数
  positiveInteger: /^\d+$/, // eslint-disable-line
  //正数字，可以有2位小数
  positiveDecimal: /^\d+(\.?\d{1,2})?$/, // eslint-disable-line
  //登录账号
  loginName: /^[a-zA-Z0-9]{6,20}$/
}

export default regx;
